import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const msnSmall133100Raw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'msan_133x100',
  className: 'msan_133x100',
  aspectRatio: 1.33,
  type: 'Image133x100',
  associationType: 'ImageMedia133X100',
  imagePreviewHeight: 75,
  minimumRequirements: 0,
  minSize: [100, 75],
  localizedText: {
    previewTypeStringKey: _TL_('MSN small headline'),
    stringKey: _TL_('1.33:1'),
  },
  previewSettings: {
    showAdsLabelWithBusinessName: true,
    showBusinessName: true,
    showImage: true,
    showShortHeadline: true,
    showShortHeadlineMultiline: true,
    showUrlMultiline: true,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    businessNameWithAds: {
      padding: '1px 0',
      marginTop: 9,
      '& .adslabel': {
        border: '.5px solid #78718a',
        color: '#78718a',
        fontSize: 10,
        fontWeight: 400,
        lineHeight: '13.64px',
        textDecorationThickness: 'auto',
        textSizeAdjust: '100%',
        borderRadius: '4px',
        background: '#fff',
        padding: '.8px 4px',
        margin: '0 5px 0 0',
      },
      '& .business-name': {
        color: '#333',
        fontSize: 11,
        lineHeight: '15.004px',
        padding: '1px 0',
      },
    },
    previewContent: {
      width: 300,
      height: 90,
      padding: 0,
    },
    imageContainer: {
      float: 'left',
      transform: 'none',
      width: 100,
      height: 75,
      margin: '8px',
    },
    textContainer: {
      color: '#333',
      fontSize: 10,
      lineHeight: '16px',
    },
    shortHeadline: {
      fontWeight: 600,
      fontSize: 13,
      lineHeight: 1.384,
      height: 52,
      overflow: 'hidden',
      margin: '4px 8px 0 8px',
    },
  },
};

export default msnSmall133100Raw;
